import { makeStyles, createStyles } from 'styles/utils';

export const useStyles = makeStyles(theme => createStyles({
  headSkeleton: {
    height: theme.spacing(2),
  },
}));